import type { BeatLineLegacySettings } from './types';

function absoluteBackendUrl(url: string | undefined, remoteSiteUrl?: string): string {
  const value = String(url || '');
  if (!value) return value;
  if (/^https?:\/\//i.test(value)) return value;
  const base = String(remoteSiteUrl || window.beatlineViteConfig?.remoteSiteUrl || 'https://beatlinegame.com').replace(/\/$/, '');
  return base + (value.startsWith('/') ? value : '/' + value);
}

export function installLegacySettings(settings: BeatLineLegacySettings): void {
  const remoteSiteUrl = window.beatlineViteConfig?.remoteSiteUrl || 'https://beatlinegame.com';
  const normalized = {
    ...settings,
    ajaxUrl: absoluteBackendUrl(settings.ajaxUrl, remoteSiteUrl),
    scanUrl: settings.scanUrl ? absoluteBackendUrl(settings.scanUrl, remoteSiteUrl) : settings.scanUrl,
  };
  window.beatlineSettings = normalized;
  window.ajaxUrl = normalized.ajaxUrl;
  window.ajaxNonce = normalized.nonce;
}

export async function ajaxPost(action: string, payload: Record<string, unknown> = {}) {
  const settings = window.beatlineSettings;
  if (!settings?.ajaxUrl || !settings?.nonce) {
    throw new Error('BeatLine ajaxUrl/nonce ontbreekt. Controleer de app-bootstrap API of native app session.');
  }
  const form = new FormData();
  form.append('action', action);
  form.append('nonce', settings.nonce);
  Object.entries(payload).forEach(([key, value]) => {
    if (Array.isArray(value)) value.forEach((item) => form.append(`${key}[]`, String(item)));
    else if (value !== undefined && value !== null) form.append(key, String(value));
  });
  const response = await fetch(settings.ajaxUrl, { method: 'POST', body: form, credentials: 'include' });
  return response.json();
}
